import useRouter from 'utils/useRouter'
import { useEffect } from 'react'
import Cookies from 'js-cookie'
import { useAuth } from '../hooks/useAuth'

export const WithAuth = ({ children }) => {
  const { isLogged, getProfile } = useAuth()
  const router = useRouter()

  useEffect(() => {
    if (Cookies.get('auth-sigep')) {
      getProfile()
    }

  }, [])

  useEffect(() => {
    async function check() {
      if (!isLogged && !Cookies.get('auth-sigep')) {
        // TODO: add toast
        router.history.push('/auth/login')
      }
    }
    check()
  }, [isLogged])

  return !!isLogged && children
}
